import React from "react";
import SupportOptions from "./sections/SupportOptions";
import PrePlanOptions from "./sections/PrePlanOptions";
import HomeMenuItem from "./sections/HomeMenuItem";
import MenuItemDivider from "../../../components/menus/MenuItemDivider";
import PostPlanOptions from "./sections/PostPlanOptions";
import MenuHeader from "./sections/MenuHeader";
import LanguageSwitcher from "../../../LanguageSwitcher";

const ConsumerMenuContent = () => {
  return (
    <>
      <MenuHeader />
      <HomeMenuItem />
      <MenuItemDivider />
      <PostPlanOptions />
      <PrePlanOptions />
      <SupportOptions />
      <LanguageSwitcher />
    </>
  );
};

export default ConsumerMenuContent;
